















































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { formatCurrency } from "@/shared/currency";
import Button from "@/shared/components/ui/Button.vue";
import {
  AdvisorEventType,
  HsabSsoDestination,
} from "@/shared/types";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import { useHsaStore } from "@/shared/store/hsa";
import { usePartnerPortalStore } from "@/employee/store/partnerPortal";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useUserAdvisorStore } from "@/shared/store/userAdvisor";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

@Component({
  components: {
    SsoDeepLink,
    Button
  }
})
export default class TaxSavingsWidget extends Vue {
  hsaStore = useHsaStore();
  partnerPortalStore = usePartnerPortalStore();
  custodianSettingsStore = useCustodianSettingsStore();
  advisorStore = useUserAdvisorStore();
  featureFlagStore = useFeatureFlagStore();

  formatCurrency = formatCurrency;

  mounted (): void {
    this.partnerPortalStore.getPartnerPortalStatus();
    this.custodianSettingsStore.getCustodianSettings();
  }

  logEvent () {
    this.advisorStore.saveEvent(AdvisorEventType.SsoTaxLinkClick);
  }

  get taxSavings (): number {
    return this.hsaStore.totalTaxSavings();
  }

  get hsabStatementsDeeplinkLocation () {
    return HsabSsoDestination.Statements;
  }
}
